<label
  [class.labelled-checkbox--disabled]="disabled()"
  [class.labelled-checkout--border]="border()"
  class="labelled-checkbox"
>
  <input
    (change)="toggleChecked()"
    [checked]="checked()"
    [disabled]="disabled()"
    class="labelled-checkbox__input"
    type="checkbox"
  />
  <div [attr.aria-hidden]="true" class="labelled-checkbox__decorator">
    <svg
      class="labelled-checkbox__svg"
      height="9px"
      viewBox="0 0 12 9"
      width="12px"
    >
      <polyline points="1 5 4 8 11 1" />
    </svg>
  </div>

  @if (label()) {
    <span class="labelled-checkbox__label">{{ label() }}</span>
  }
</label>
